// extracted by mini-css-extract-plugin
module.exports = {"image":"TwoImgsWithBtns-module--image--2rKur","button":"TwoImgsWithBtns-module--button--3m9ZT"};